module.exports = __webpack_public_path__ + "img/store-apple.8da1c89.svg";